export default "__VITE_ASSET__BeAwnhj0__"